













































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import YcColorPicker from "@/components/color-picker/index.js";
import {FormWheelOfFortuneSettingsVO, FormWheelSliceVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import discountDialog from '../components/discountDialog.vue';
import PopUnifiedDiscountSettingsDialog from '@/views/wheelOfFortune/components/PopUnifiedDiscountSettingsDialog.vue';
import { isEnablePopUnifiedDiscountCode } from '@/utils/experiment';

enum permissionType {EDIT = 'edit', CHECK = 'check'}

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
    "yc-color-picker": YcColorPicker,
    discountDialog: discountDialog,
    PopUnifiedDiscountSettingsDialog,
  },
})
export default class wheelOfFortuneSetting extends Vue {
  @Prop(Array)
  tableData!:FormWheelSliceVO[];

  @Prop(Object)
  formData!: TFormSaveDetailRequest;


  public permission = '';
  public permissionType = permissionType;

  showDiscountDialog = false;
  editDiscountIndex = -1;
  discountData = {};

  get showDiscountSetting() {
  return sessionStorage.getItem('isShopify') === '1';
    // const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    // const companyId = company?.id;
    // return (companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681);
  }

  get useUnifiedDiscountSettings() {
    return isEnablePopUnifiedDiscountCode();
  }


  changeDiscountType(row:any, index: number) {
    if (row.discountType === 'guding') {
      row.discount = null;
      this.tableData[index].discount = null;
      this.showDiscountDialog = false;
      this.discountData = {};
      this.editDiscountIndex = -1;
    } else {
      this.editDiscountIndex = index;
      this.discountData = JSON.parse(JSON.stringify(this.tableData?.[this.editDiscountIndex]?.discount||{
      valueType: 2,
      minBuyRequireType: 0}));
      this.openDiscountDialog();
    }
    row.discountType = 'guding';
    this.tableData[index].discountType = 'guding';
  }
  openDiscountDialog() {
    this.showDiscountDialog = false;
    this.$nextTick(() => {
      this.showDiscountDialog = true;
    });
  }
  showDiscountDialogHandle(index: number) {
    this.editDiscountIndex = index;
    this.discountData = JSON.parse(JSON.stringify(this.tableData?.[this.editDiscountIndex]?.discount||{
      valueType: 2,
      minBuyRequireType: 0}));
    this.openDiscountDialog();
  }
  saveDiscount(discount:any) {
    this.tableData[this.editDiscountIndex].couponCode = '';
    this.tableData[this.editDiscountIndex].discount = discount;
    this.tableData[this.editDiscountIndex].discountType = 'dongtai';
    this.showDiscountDialog = false;
    this.discountData = {};
    this.editDiscountIndex = -1;
  }
  closeDiscount() {
    if (this.tableData[this.editDiscountIndex].discountType === 'guding') {
      this.tableData[this.editDiscountIndex].discountType = 'guding';
    }
    this.showDiscountDialog = false;
    this.discountData = {};
    this.editDiscountIndex = -1;
  }


  async created(): Promise<void> {
    if(this.$route.path.match(new RegExp('^/wheel_of_fortune/check/[^/]*$'))) {
      this.permission = permissionType.CHECK;
    }
  }

  async mounted(): Promise<void> {
    for (let i = 0; i < this.tableData?.length; i++) {
      const data = this.tableData?.[i];
      // if (!data.discountType) {
        if (!!data.couponCode || !data.discount) {
          data.discountType = 'guding';
        } else {
          data.discountType = 'dongtai';
        }
      // }
    }
  }


  /**
   * 下一步
   */
   nextStep() {
    this.$emit('nextStep')
  }

  /**
   * 上一步
   */
  backStep() {
    this.$emit('backStep')
  }

  /**
   * 取消
   */
  cancel() {
    this.$emit('cancel')
  }

}
